import RouterLayout from './layouts/RouterLayout.vue';
export default {
  name: "App",
  components: {
    RouterLayout
  }
};